
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"21","height":"21","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M15.75 1.969h-2.087a1.969 1.969 0 00-1.85-1.313H9.187a1.969 1.969 0 00-1.85 1.313H5.25a1.969 1.969 0 00-1.969 1.968v13.126A1.969 1.969 0 005.25 19.03h10.5a1.969 1.969 0 001.969-1.968V3.938a1.969 1.969 0 00-1.969-1.97zm-7.219.656a.656.656 0 01.656-.656h2.626a.656.656 0 01.656.656v.656H8.53v-.656zm7.875 14.438a.656.656 0 01-.656.656H5.25a.656.656 0 01-.656-.657V3.938a.656.656 0 01.656-.656h1.969v1.313h6.562V3.28h1.969a.656.656 0 01.656.656v13.126z","fill":"#2F6BF0"}}),_c('path',{attrs:{"d":"M13.781 9.844H7.22v1.312h6.562V9.844zM10.5 12.469H7.219v1.312H10.5V12.47z","fill":"#2F6BF0"}})])
          )
        }
      }
    